import React from 'react';
import {
  columnDataAvancedFilter, getAutoAssignStatusFilterOptions, getTaskPriorityFilterOptions, getTaskStatusFilterOptions
} from 'OldComponents/AdvancedFilter/AvancedFilterUtil';
import AdvancedFilterUtilOperator from 'OldComponents/AdvancedFilter/AdvancedFilterUtilOperator';
import {
  AgentCell, createFunctionalityQuestionCell, DateCell, EllipsisAddressLinkCell, EllipsisTextCell,
  getFunctionalityQuestionDisplayValue, InventoryAssetStatusCell, normalizeFunctionalityKey, ParentTaskCell,
  ParentTaskTypeCell, PhoneCell, PriorityCell, StarRatingCell, StatusCell, TaskDetailButton, TaskFunctionalitiesCell,
  TaskIconCell, TaskTagsCell, TaskTypeCell, toColumnId
} from '~/FielderElements/SmartTaskTable/SmartTaskCells';
import FormStatus from 'FielderUtils/forms/FormsTable/FormStatus';
import FormReviewable from 'FielderUtils/forms/FormsTable/FormReviewable';
import { Box, IconButton, Tooltip } from '@mui/material';
import AssignResourcesIcon from '@assets/icons/assign-resources-icon.svg';
import CreateGroupTask from '@assets/icons/create-group-tasks.svg';
import { validatePermissions } from 'FielderUtils/validatePermissions';
import POPUPNAME from 'FielderUtils/popupName/popupName';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import LANGUAGE from 'FielderUtils/languages/fielderLanguages';
import { FIELDER } from '@core/constants/base.constants';
import IconFormatterInvitation from '../../../oldComponents/SmartTable/IconFormatterInvitation';
import IconFormatterWarning from '../../../oldComponents/SmartTable/IconFormatterWarning';
import RouteStatus from '../../../oldComponents/Status/RouteStatus';
import AssetStatusFormatter from '../../../oldComponents/SmartTable/AssetStatusFormatter';
import InvitationStatusFormatter from '../../../oldComponents/SmartTable/InvitationStatusFormatter';
import RowMenuOptions from '../../../oldComponents/SmartTable/RowMenuOptions';
import LocationFormatter from '../../../oldComponents/SmartTable/LocationFormatter';
import AccountStatusFormatter from '../../../oldComponents/SmartTable/AccountStatusFormatter';
import AgentFormatter from '../../../oldComponents/SmartTable/AgentFormatter';
import AutoAssignTaskStatus from 'OldComponents/Status/AutoAssignTaskStatus';
import { DatePicker, TreeSelect } from 'antd';
import moment from 'moment';
import CellIsochronous from '../../../pages/IsochronousPage/components/CellIsochronous';
import CellType from '../../../pages/IsochronousPage/components/CellType';
import CellUsersNumber from '../../../pages/IsochronousPage/components/CellUsersNumber';
import LocationIcon from '@mui/icons-material/LocationOn';
import TextIcon from '~/TextIcon/TextIcon.component';

export const buildFunctionalityQuestionColumns = (selection, searchFunctionalities, lan) => {
  if (!selection) return [];
  const columns = [];
  Object.entries(selection).forEach(([typeKey, entry]) => {
    if (typeKey === 'functionalitiesFilterParams') return;
    const normalizedKey = normalizeFunctionalityKey(typeKey, searchFunctionalities);
    if (!normalizedKey) return;
    const items = Array.isArray(entry?.items) ? entry.items : [];
    items.forEach((item) => {
      const fields = Array.isArray(item?.fields) ? item.fields : [];
      fields
        .filter((field) => field && field.visible !== false && field.disabled !== true)
        .forEach((field) => {
          const columnId = toColumnId(normalizedKey, item.id, field.id);
          const cellOptions = {
            functionalityKey: normalizedKey,
            itemId: item.id,
            questionId: field.id,
            questionType: field.type,
            searchFunctionalities,
          };
          columns.push({
            id: columnId,
            header: field.label ?? `Question ${field.id ?? ''}`,
            accessorFn: (row) => {
              const formatted = getFunctionalityQuestionDisplayValue(
                row?.functionalities, {
                ...cellOptions, lan, row
              });
              return typeof formatted === 'object' && formatted !== null ? formatted.text : formatted;
            },
            enableSorting: true,
            enableColumnDragging: true,
            enableColumnResizing: true,
            filterVariant: 'text',
            Cell: createFunctionalityQuestionCell(lan, cellOptions),
            meta: {
              functionalityType: normalizedKey,
              functionalityId: item.id,
              questionId: field.id,
            },
          });
        });
    });
  });
  return columns;
};
export const localeMap = {
  [LANGUAGE.en]: MRT_Localization_EN,
  [LANGUAGE.es]: MRT_Localization_ES,
  [LANGUAGE.mx]: MRT_Localization_ES,
  [LANGUAGE.latam]: MRT_Localization_ES,
  [LANGUAGE.pt]: MRT_Localization_PT_BR,
};
export const getNoRecordsToDisplay = (lan, smartTableId, baseLocalization, option) => {
  switch (smartTableId) {
    case FIELDER.smartTableId.TASK:
      return (
        lan.notFoundRecordsAdvancedFilter ||
        baseLocalization.noRecordsToDisplay ||
        'No records to display'
      );
    case FIELDER.smartTableId.PARTNER:
      let txtLang = '';
      if (option === 0) txtLang = lan.noInvitations;
      else if (option === 1) txtLang = lan.noIamNotPartner;
      else if (option === 2) txtLang = lan.noMyPartners;
      else txtLang = baseLocalization.noRecordsToDisplay || 'No records to display'
      return (txtLang);
    default:
      return (
        baseLocalization.noRecordsToDisplay ||
        'No records to display'
      );
  }
};
export const getUserLanguage = (lan, smartTableId, option) => {
  const langCode = lan?.getLanguage?.() ?? LANGUAGE.en;
  const baseLocalization = localeMap[langCode] ?? MRT_Localization_EN;
  // Merge MRT localization with localization language
  return {
    ...baseLocalization,
    noRecordsToDisplay:
    getNoRecordsToDisplay(lan, smartTableId, baseLocalization, option),
  };
};
export const AdaptAdvancedFilters = (filters) => {
  if (!Array.isArray(filters)) return null;
  const columns = columnDataAvancedFilter();
  const legacy = [];
  const process = (f, isParent = true, parentCol = f.column) => {
    legacy.push({
      operator: f.operator ?? AdvancedFilterUtilOperator.WHERE,
      columSelected: f.column,
      label: columns.find((c) => c.value === f.column)?.label ?? '',
      operation: f.operation,
      valueField: f.value,
      parent: parentCol,
      isParent,
      countCategory: f.countCategory,
    });
    if (Array.isArray(f.subFilters)) {
      f.subFilters.forEach((sf) => process(sf, false, parentCol));
    }
  };
  filters.forEach((f) => process(f, f.isParent !== false, f.parent ?? f.column));
  const counts = legacy.reduce((acc, item) => {
    acc[item.columSelected] = (acc[item.columSelected] ?? 0) + 1;
    return acc;
  }, {});
  legacy.forEach((item) => {
    if (item.countCategory === undefined || item.countCategory === null)
      item.countCategory = counts[item.columSelected];
  });
  return legacy;
};
export const RenderResourceMenuButton = (
  {
    user, showDisable, showTaskByEmail, showRouteOpt, OPTION_TASK,
    canGenerateResourceAllocation, canCreateGroupTasks, lan, props
  }) => (
  <>
    {!showDisable &&
      !showTaskByEmail &&
      OPTION_TASK === 1 && (
        <>
          {showRouteOpt &&
            validatePermissions(
              user, { showDisabledTasks: showDisable, showTaskByEmail }, 'route') &&
            canGenerateResourceAllocation && (
              <>
                {validatePermissions(
                  user, { showDisabledTasks: showDisable, showTaskByEmail }, 'resource') && (
                  <Tooltip title={lan.assignResources || 'Assign Resources'}>
                    <IconButton
                      id='MyOperation-assign-resources-icon'
                      onClick={() => props.changePopupState(POPUPNAME.ASSIGN_RESOURCES)}
                      size="small"
                    >
                      <img
                        id='MyOperation-assign-resources-icon'
                        src={AssignResourcesIcon}
                        alt={lan.assignResources}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                {!RoleUtils.isUserClient(user) && ''}
              </>
            )}
        </>
      )}

    {OPTION_TASK === 3 && canCreateGroupTasks && (
      <Tooltip title={lan.titleIconGroup || 'Create a task group'}>
        <IconButton
          id="MyOperation-export-icon"
          onClick={() => {
            props.changePopupState(POPUPNAME.CREATE_GROUP_TASK);
            props.resetGroupTaskSectionView();
          }}
          size="small"
        >
          <img src={CreateGroupTask} alt={lan.titleIconGroup} />
        </IconButton>
      </Tooltip>
    )}
  </>
);
//COLUMNS
const findTaskTypeByValue = (tree, value) => {
  for (const node of tree) {
    if (node.value === value) return node;
    if (node.children && node.children.length) {
      const found = findTaskTypeByValue(node.children, value);
      if (found) return found;
    }
  }
  return null;
};
export const buildTaskTableColumns = (
  lan, handleOpenDetail, disabledDetailButton, priorityOfTasks, typeOfTasks, centeredColumns = []) => {
  const columns = [
    {
      id: 'taskIcons',
      accessorKey: 'taskIcons',
      header: '',
      size: 150,
      minSize: 150,
      maxSize: 150,
      enablePinning: false,
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnOrdering: false,
      Cell: ({ row }) => (
        <TaskIconCell
          value={row.original.taskIcons}
          row={row.original}
          idKey='taskIcons'
          disabledDetailButton={disabledDetailButton}
        />
      ),
    },
    {
      id: 'taskId',
      accessorKey: 'taskId',
      header: lan.idTask || 'taskId',
      enableColumnOrdering: false,
      enableColumnActions: false,
      filterFn: (row, columnId, filterValue) =>
        row.getValue(columnId)?.toString().includes(filterValue?.toString()),
      Cell: ({ row }) => (
        <TaskDetailButton
          value={row.original.taskId}
          row={row.original}
          idKey='taskId'
          onClick={() => handleOpenDetail(row.original)}
          disabledDetailButton={disabledDetailButton}
        />
      ),
    },
    {
      id: 'functionalities',
      accessorKey: 'functionalities',
      header: '',
      enablePinning: false,
      enableSorting: false,
      enableColumnFilter: false,
      enableColumnActions: false,
      enableColumnOrdering: false,
      Cell: ({ row }) => (
        <TaskFunctionalitiesCell
          value={row.original.functionalities}
          row={row.original}
          idKey='functionalities'
        />
      ),
    },
    {
      id: 'customId',
      accessorKey: 'customId',
      header: lan.customId || 'customId',
      enableClickToCopy: true,
      enableColumnOrdering: true,
      enableColumnActions: false,
      filterFn: (row, columnId, filterValue) =>
        row.getValue(columnId)?.toString().includes(filterValue?.toString()),
    },
    {
      id: 'folio', accessorKey: 'folio', header: lan.folio || 'folio',
      enableClickToCopy: true, enableColumnActions: false,
    },
    {
      id: 'priority', accessorKey: 'priority', header: lan.priority || 'priority', size: 150, maxSize: 180,
      enableColumnActions: false,
      accessorFn: row => String(row.priority),
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        const options = getTaskPriorityFilterOptions(priorityOfTasks, lan).map(opt => ({
          title: opt.label,
          value: String(opt.value),
          key: String(opt.value)
        }));
        return (
          <TreeSelect
            style={{ width: '100%' }}
            treeData={options}
            allowClear
            showSearch={false}
            placeholder={lan.priority || 'Priority'}
            dropdownStyle={{ maxHeight: 400, zIndex: 1500, overflow: 'auto' }}
            value={currentValue || undefined}
            onChange={(value) => column.setFilterValue(value || undefined)}
            filterTreeNode={(input, treeNode) =>
              treeNode.title.toLowerCase().includes(input.toLowerCase())
            }
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        return String(row.original.priority) === String(filterValue);
      },
      Cell: ({ row }) => (
        <PriorityCell value={row.original.priority} row={row.original} idKey='priority' />
      ),
    },
    {
      id: 'mainTaskType',
      accessorKey: 'mainTaskType',
      header: lan.mainTaskType || 'mainTaskType',
      size: 150,
      minSize: 90,
      maxSize: 150,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <ParentTaskTypeCell
          value={row.original.mainTaskType}
          row={row.original}
          idKey='mainTaskType'
        />
      ),
    },
    {
      id: 'taskType', accessorKey: 'taskType', header: lan.taskType || 'taskType', enableColumnActions: false,
      accessorFn: row => lan[`${row.taskType}`] || row.taskType,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <TreeSelect
            style={{ width: '100%' }}
            treeData={typeOfTasks}
            allowClear
            showSearch={false}
            placeholder={lan.taskType}
            dropdownStyle={{ maxHeight: 400, zIndex: 1500, overflow: 'auto' }}
            value={currentValue || undefined}
            onChange={(value) => column.setFilterValue(value || undefined)}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const selectedType = findTaskTypeByValue(typeOfTasks, filterValue);
        const selectedTranslatedName = selectedType ? selectedType.originName : String(filterValue);
        return row.original.taskType.toLowerCase() === selectedTranslatedName.toLowerCase();
      },
      Cell: ({ row }) => {
        return (
          <TaskTypeCell value={row.original.taskType} row={row.original} idKey='taskType' />
        );
      }
    },
    {
      id: 'status', accessorKey: 'status', header: lan.status || 'status', size: 150, minSize: 100, maxSize: 190,
      enableColumnActions: false, filterVariant: 'select',
      accessorFn: row => String(row.status),
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        const options = getTaskStatusFilterOptions(lan).map(opt => ({
          title: opt.label,
          value: String(opt.value),
          key: String(opt.value)
        }));
        return (
          <TreeSelect
            style={{ width: '100%' }}
            treeData={options}
            allowClear
            showSearch={false}
            placeholder={lan.status || 'Status'}
            dropdownStyle={{ maxHeight: 400, zIndex: 1500, overflow: 'auto' }}
            value={currentValue || undefined}
            onChange={(value) => column.setFilterValue(value || undefined)}
            filterTreeNode={(input, treeNode) =>
              treeNode.title.toLowerCase().includes(input.toLowerCase())
            }
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        return String(row.original.status) === String(filterValue);
      },
      Cell: ({ row }) => {
        return (
          <StatusCell value={row.original.status} row={row.original} idKey='status' />
        );
      }
    },
    {
      id: 'parentTask',
      accessorKey: 'idParentTask',
      header: lan.idParentTask || 'idParentTask',
      enableColumnActions: false,
      Cell: ({ row }) => (
        <ParentTaskCell
          value={row.original.parentTask}
          row={row.original}
          idKey='parentTask'
        />
      ),
    },
    { id: 'partner', accessorKey: 'partner', enableColumnActions: false, header: lan.partner || 'partner' },
    {
      id: 'tags',
      accessorKey: 'tags',
      header: lan.tags || 'tags',
      enableClickToCopy: true,
      enableColumnActions: false,
      Cell: ({ row }) => <TaskTagsCell value={row.original.tags} row={row.original} idKey='tags' />,
    },
    {
      id: 'taskUser',
      accessorKey: 'taskUser',
      header: lan.companyClient || 'companyClient',
      enableClickToCopy: true,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <EllipsisTextCell
          value={row.original.taskUser}
          row={row.original}
          idKey='taskUser'
        />
      ),
    },
    { id: 'branch', accessorKey: 'branch', enableColumnActions: false, header: lan.branch || 'branch' },
    {
      id: 'branchLocationAddress',
      accessorKey: 'branchLocationAddress',
      header: lan.branchLocationAddress || 'branchLocationAddress',
      enableColumnActions: false,
      Cell: ({ row }) => (
        <EllipsisAddressLinkCell
          value={row.original.branchLocationAddress}
          row={row.original}
          idKey='branchLocationAddress'
        />
      ),
    },
    {
      id: 'branchCellPhoneContact',
      accessorKey: 'branchCellPhoneContact',
      header: lan.branchCellPhoneContact || 'branchCellPhoneContact',
      size: 200,
      minSize: 150,
      enableClickToCopy: true,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <PhoneCell
          value={row.original.branchCellPhoneContact}
          row={row.original}
          idKey='branchCellPhoneContact'
        />
      ),
    },
    {
      id: 'branchOfficePhoneContact',
      accessorKey: 'branchOfficePhoneContact',
      header: lan.branchOfficePhoneContact || 'branchOfficePhoneContact',
      size: 200,
      minSize: 150,
      enableClickToCopy: true,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <PhoneCell
          value={row.original.branchOfficePhoneContact}
          row={row.original}
          idKey='branchOfficePhoneContact'
        />
      ),
    },
    { id: 'country', accessorKey: 'country', header: lan.country || 'country' },
    { id: 'state', accessorKey: 'state', header: lan.state || 'state' },
    { id: 'municipality', accessorKey: 'municipality', header: lan.municipality || 'municipality' },
    {
      id: 'creationTime', accessorKey: 'creationTime', header: lan.creationTime || 'creationTime', enableColumnActions: false,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <DatePicker
            style={{ zIndex: 1500, width: '100%' }}
            allowClear
            format="D/M/YYYY"
            placeholder={lan.creationTime || 'Creation Time'}
            value={currentValue ? moment(Number(currentValue)) : null}
            onChange={(date) => {
              column.setFilterValue(date ? date.valueOf() : undefined);
            }}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const rowTime = Number(row.original.creationTime);
        if (!rowTime) return false;
        const rowDate = moment(rowTime).format('YYYY-MM-DD');
        const filterDate = moment(Number(filterValue)).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
      Cell: ({ row }) => {
        return (
          <DateCell value={row.original.creationTime} row={row.original} idKey='creationTime' />
        )},
    },
    {
      id: 'startDateTimeRange', accessorKey: 'startDateTimeRange',
      header: lan.startDateTimeRange || 'startDateTimeRange', enableColumnActions: false,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <DatePicker
            style={{ zIndex: 1500, width: '100%' }}
            allowClear
            format="D/M/YYYY"
            placeholder={lan.startDateTimeRange || 'Start date range'}
            value={currentValue ? moment(Number(currentValue)) : null}
            onChange={(date) => {
              column.setFilterValue(date ? date.valueOf() : undefined);
            }}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const rowTime = Number(row.original.startDateTimeRange);
        if (!rowTime) return false;
        const rowDate = moment(rowTime).format('YYYY-MM-DD');
        const filterDate = moment(Number(filterValue)).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
      Cell: ({ row }) => {
        return (
          <DateCell value={row.original.startDateTimeRange} row={row.original} idKey='startDateTimeRange' />
        )},
    },
    {
      id: 'endDateTimeRange', accessorKey: 'endDateTimeRange',
      header: lan.endDateTimeRange || 'endDateTimeRange', enableColumnActions: false,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <DatePicker
            style={{ zIndex: 1500, width: '100%' }}
            allowClear
            format="D/M/YYYY"
            placeholder={lan.endDateTimeRange || 'End date range'}
            value={currentValue ? moment(Number(currentValue)) : null}
            onChange={(date) => {
              column.setFilterValue(date ? date.valueOf() : undefined);
            }}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const rowTime = Number(row.original.endDateTimeRange);
        if (!rowTime) return false;
        const rowDate = moment(rowTime).format('YYYY-MM-DD');
        const filterDate = moment(Number(filterValue)).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
      Cell: ({ row }) => {
        return (
          <DateCell value={row.original.endDateTimeRange} row={row.original} idKey='endDateTimeRange' />
        )},
    },
    {
      id: 'agent',
      accessorKey: 'agent',
      header: lan.agent || 'agent', enableColumnActions: false,
      Cell: ({ row }) => <AgentCell value={row.original.agent} row={row.original} idKey='agent' />,
    },
    {
      id: 'startTime', accessorKey: 'startTime', header: lan.startTime || 'startTime', enableColumnActions: false,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <DatePicker
            style={{ zIndex: 1500, width: '100%' }}
            allowClear
            format="D/M/YYYY"
            placeholder={lan.startTime || 'Start Time'}
            value={currentValue ? moment(Number(currentValue)) : null}
            onChange={(date) => {
              column.setFilterValue(date ? date.valueOf() : undefined);
            }}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const rowTime = Number(row.original.startTime);
        if (!rowTime) return false;
        const rowDate = moment(rowTime).format('YYYY-MM-DD');
        const filterDate = moment(Number(filterValue)).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
      Cell: ({ row }) => {
        return (
        <DateCell value={row.original.startTime} row={row.original} idKey='startTime' />
      )},
    },
    {
      id: 'endTime', accessorKey: 'endAgent', header: lan.endAgent || 'endAgent', enableColumnActions: false,
      Filter: ({ column }) => {
        const currentValue = column.getFilterValue();
        return (
          <DatePicker
            style={{ zIndex: 1500, width: '100%' }}
            allowClear
            format="D/M/YYYY"
            placeholder={lan.endAgent || 'End Time'}
            value={currentValue ? moment(Number(currentValue)) : null}
            onChange={(date) => {
              column.setFilterValue(date ? date.valueOf() : undefined);
            }}
          />
        );
      },
      filterFn: (row, _columnId, filterValue) => {
        if (!filterValue) return true;
        const rowTime = Number(row.original.endAgent);
        if (!rowTime) return false;
        const rowDate = moment(rowTime).format('YYYY-MM-DD');
        const filterDate = moment(Number(filterValue)).format('YYYY-MM-DD');
        return rowDate === filterDate;
      },
      Cell: ({ row }) => (
        <DateCell value={row.original.endTime} row={row.original} idKey='endTime' />
      ),
    },
    {
      id: 'ratingClientTask',
      accessorKey: 'ratingClientTask',
      header: lan.ratingClientTask || 'ratingClientTask',
      size: 200,
      minSize: 150,
      enableColumnActions: false,
      Cell: ({ row }) => (
        <StarRatingCell
          value={row.original.ratingClientTask}
          row={row.original}
          idKey='ratingClientTask'
        />
      ),
    },
  ];
  if (Array.isArray(centeredColumns) && centeredColumns.length) {
    columns.forEach((column) => {
      if (centeredColumns.includes(column.id)) {
        column.muiTableHeadCellProps = {
          ...(column.muiTableHeadCellProps ?? {}),
          align: 'center',
        };
        column.muiTableBodyCellProps = {
          ...(column.muiTableBodyCellProps ?? {}),
          align: 'center',
        };
        if (column.Cell) {
          const OriginalCell = column.Cell;
          column.Cell = (cellProps) => (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <OriginalCell {...cellProps} />
            </Box>
          );
        }
      }
    });
  }
  return columns;
};
export const getSmartUserTableColumns = (elements, smartTableId, lan, props) => {
  const headers = elements.length ? Object.keys(elements[0]) : [];
  switch (smartTableId) {
    case FIELDER.smartTableId.BRANCH:
      const branchHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'showLocationIcon',
          'idBranch',
          'idCustomBranch',
          'branchNameText',
          'companyIdAndName',
          'address',
        ];
      return branchHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'showLocationIcon': return {
            ...baseCol, header: '', enableColumnFilter: false, enableColumnActions: false, enableColumnOrdering: false,
            size: 40, enableSorting: false, Cell: ({ row }) =>
              <LocationFormatter showLocationIcon={row.original.showLocationIcon} /> };
          case 'idBranch': return {
            ...baseCol, enableColumnOrdering: false, size: 40, grow: true, enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'idCustomBranch': return { ...baseCol, size: 330, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'branchNameText': return { ...baseCol, size: 300, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'companyIdAndName': return { ...baseCol, size: 300, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'address': return { ...baseCol, size: 250, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
        }
      });
    case FIELDER.smartTableId.ADMIN:
      const adminHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'idUser',
          'name',
          'userName',
          'email',
          'mobileNumber',
          'jobPosition',
        ];
      return adminHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'idUser': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'email': return { ...baseCol, size: 200, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'mobileNumber': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => <PhoneCell value={cell.getValue()} />};
          case 'jobPosition': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.MANAGER:
      const managerHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'idUser',
          'name',
          'email',
          'mobileNumber',
          'jobPosition',
          'teamNames',
        ];
      return managerHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'idUser': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'email': return { ...baseCol, size: 250, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'mobileNumber': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => <PhoneCell value={cell.getValue()} />};
          case 'jobPosition': return { ...baseCol, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'teamNames': return { ...baseCol, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.AGENT:
      const agentHeaders = headers.length
        ? headers
        : [
          'idAgent',
          'name',
          'userName',
          'mobileNumber',
          'company',
          'email',
          'plate',
          'skills',
          'agentTeamList',
        ];
      return agentHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'idAgent': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) =>
              <EllipsisTextCell value={cell.getValue()} />};
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'mobileNumber': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'company': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'email': return { ...baseCol, size: 200, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'plate': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'skills': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) =>
              <EllipsisTextCell value={cell.getValue()} />};
          case 'agentTeamList': return {
            ...baseCol, size: 50, grow: true, enableColumnFilter: false, enableColumnActions: false,
            enableSorting: false, Cell: ({ row }) =>
              <RowMenuOptions
                value={row.original.agentTeamList} row={row.original} lan={lan} onRowMenuClick={props.onRowMenuClick} />};
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.PARTNER:
      const partnerHeaders = headers.length
        ? headers
        : [
          'iconInvitation',
          'accountStatus',
          'configIdAccount',
          'name',
          'companyBranch',
          'email',
          'statusInvitation',
        ];
      return partnerHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconInvitation': return {
            ...baseCol, header: '', size: 40, grow: true, enableColumnFilter: false, enableColumnActions: false,
            enableColumnOrdering: false, enableSorting: false, Cell: IconFormatterInvitation };
          case 'accountStatus': return {
            ...baseCol, header: '', size: 40, grow: true, enableColumnFilter: false, enableColumnActions: false,
            enableColumnOrdering: false, enableSorting: false, Cell: ({ row }) => {
              return (
                <AccountStatusFormatter value={row.original?.accountStatus} lan={lan} />
              );
            }
          };
          case 'idAccount': return { ...baseCol, size: 40, maxSize:100, grow: false, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'idAccountParent': return { ...baseCol, size: 40, grow: false, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'configIdAccount': return { ...baseCol, size: 40, grow: false, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'companyBranch': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'email': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'statusInvitation': return {
            ...baseCol, size: 190, grow: true, enableColumnFilter: false, enableColumnActions: false,
            enableColumnOrdering: false, enableSorting: false, Cell: ({ cell }) =>
              <InvitationStatusFormatter value={cell.getValue()} lan={lan} /> };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.CLIENT:
      const clientHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'showLocationIcon',
          'idUserHeader',
          'name',
          'userName',
          'idBranches',
          'email',
          'mobileNumber',
          'jobPosition',
        ];
      return clientHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'showLocationIcon': return {
            ...baseCol, header: '', size: 40, grow: true, enableColumnFilter: false, enableColumnActions: false,
            enableColumnOrdering: false, enableSorting: false, Cell: ({ row }) =>
              <LocationFormatter showLocationIcon={row.original.showLocationIcon} /> };
          case 'idUserHeader': return { ...baseCol, size: 200, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'idBranches': return { ...baseCol, size: 180, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'email': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'mobileNumber': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => <PhoneCell value={cell.getValue()} />};
          case 'jobPosition': return { ...baseCol, size: 180, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.COMPANY:
      const companyHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'idCompany',
          'companyIdCustom',
          'companyName',
          'businessName',
          'parentCompanyNameText',
          'contractNumber',
        ];
      return companyHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'idCompany': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'companyIdCustom': return { ...baseCol, size: 250, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'companyName': return { ...baseCol, size: 250, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'businessName': return { ...baseCol, size: 250, maxSize: 250, grow: false,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'parentCompanyNameText': return { ...baseCol, size: 250, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'contractNumber': return { ...baseCol, size: 180, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => cell.getValue() };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.ACCOUNT:
      const accountHeaders = headers.length
        ? headers
        : [
          'configIdAccount',
          'name',
          'configBusinessName',
          'userName',
          'assetStatus',
        ];
      return accountHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'configIdAccount': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'configBusinessName': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'assetStatus': return { ...baseCol, size: 90, grow: true, enableColumnFilter: false, Cell: (cell) =>
              <AssetStatusFormatter {...cell} />};
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.GLOBAL_USER:
      const globalUserHeaders = headers.length
        ? headers
        : [
          'idGlobalAccount',
          'accountName',
          'contactName',
          'contactEmail',
          'country',
          'globalUseridUser',
          'globalUserNormalName',
          'lastName',
          'userName',
          'allGlobalAccountInfo',
        ];
      return globalUserHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'idGlobalAccount': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'accountName': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'contactName': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'contactEmail': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'country': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'globalUseridUser': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'globalUserNormalName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'lastName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'allGlobalAccountInfo': return {
            ...baseCol, size: 0, grow: false, header: '', enableHiding: true, enableSorting: false,
            enableColumnDragging: false, enableColumnResizing: false, enableColumnActions: false, Cell: () => null,
          };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.RECORDS:
      const recordsHeaders = headers.length
        ? headers
        : [
          'configIdAccount',
          'idRoute',
          'user',
          'idTask',
          'name',
          'configBusinessName',
          'userName',
          'assetStatus',
          'executionDate',
          'date',
          'role',
          'action',
        ];
      return recordsHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'configIdAccount': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'idRoute': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'user': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'idTask': return { ...baseCol, size: 40, grow: true, filterVariant: 'text', enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'configBusinessName': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'userName': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'assetStatus': return {
            ...baseCol, size: 90, grow: true, enableColumnFilter: false, Cell: (cell) =>
              <AssetStatusFormatter {...cell} /> };
          case 'executionDate': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'date': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'role': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'action': return { ...baseCol, size: 180, grow: true, Cell: ({ cell }) => cell.getValue() };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.TEAM:
      const teamHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'idTeamHeader',
          'name',
          'manager',
          'email',
        ];
      return teamHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'idTeamHeader': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 300, grow: true, Cell: ({ cell }) =>
              <EllipsisTextCell value={cell.getValue()} />};
          case 'manager': return { ...baseCol, grow: true, Cell: ({ cell }) =>
              <EllipsisTextCell value={cell.getValue()} />};
          case 'email': return { ...baseCol, grow: true, enableClickToCopy: true, Cell: ({ cell }) =>
              <EllipsisTextCell value={cell.getValue()} />};
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.ROUTES:
      const routesHeaders = headers.length
        ? headers
        : [
          'iconWarning',
          'id',
          'name',
          'routeStatus',
          'totalTasks',
          'executionFormattedDate',
          'startedFormattedDate',
          'finishedFormattedDate',
          'emergencies',
          'agent',
          'totalShipment',
        ];
      return routesHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'iconWarning': return {
            ...baseCol, header: '', size: 40, grow: true, enableSorting: false, Cell: ({ row }) =>
              <IconFormatterWarning row={row.original} iconWarning={row.original.iconWarning} /> };
          case 'id': return {
            ...baseCol, enableColumnOrdering: false, size: 40, grow: true, enableClickToCopy: true,
            filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true, Cell: ({ cell }) => cell.getValue() };
          case 'routeStatus': return { ...baseCol, size: 200, grow: true, enableColumnFilter: false,
            Cell: ({ cell }) => <RouteStatus value={cell.getValue()} />};
          case 'totalTasks': return {
            ...baseCol, enableColumnOrdering: false, size: 40, grow: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'executionFormattedDate': return { ...baseCol, size: 150, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'startedFormattedDate': return { ...baseCol, size: 150, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'finishedFormattedDate': return { ...baseCol, size: 150, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'emergencies': return { ...baseCol, size: 200, grow: true, enableClickToCopy: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'agent': return { ...baseCol, size: 100, grow: true,
            Cell: ({ cell }) => <AgentFormatter value={cell.getValue()} lan={lan} />};
          case 'totalShipment': return { ...baseCol, size: 40, grow: true,
            Cell: ({ cell }) => cell.getValue() };
        }
      });
    case FIELDER.smartTableId.INVENTORY:
      const inventoryHeaders = headers.length
        ? headers
        : [
          'id',
          'name',
          'brand',
          'type',
          'model',
          'serialNumber',
          'contractNumber',
          'status',
          'activeStatus',
          'categoryId'
        ];
      return inventoryHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'id': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'brand': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'type': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'model': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'serialNumber': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'contractNumber': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'status': return { ...baseCol,
            grow: true, enableSorting: false, enableColumnFilter: false,
            enableColumnActions: false, enableColumnOrdering: false,
            Cell: ({ cell }) => <InventoryAssetStatusCell value={cell.getValue()} maxLength={15} /> };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.ASSET:
      const assetHeaders = headers.length
        ? headers
        : [
          'id',
          'name',
          'branch',
          'company',
          'status',
          'brand',
          'type',
          'model',
          'serialNumber',
          'contractNumber',
          'activeStatus',
          'categoryId'
        ];
      return assetHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'id': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'branch': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'company': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'brand': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'type': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'model': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'serialNumber': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'contractNumber': return {
            ...baseCol, size: 80, enableColumnActions: false, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} />};
          case 'status': return { ...baseCol,
            grow: true, enableSorting: false, enableColumnFilter: false,
            enableColumnActions: false, enableColumnOrdering: false,
            Cell: ({ cell }) => <InventoryAssetStatusCell value={cell.getValue()} maxLength={15} /> };
          default:
            return baseCol;
        }
      });
    case FIELDER.smartTableId.FORM:
      const formHeaders = headers.length
        ? headers
        : [
          'id',
          'name',
          'numberFields',
          'originType',
          'status',
          'reviewable',
          'partnerPermissions',
          'creationDate',
          'lastUpdateDate',
          'responsible',
        ];
      return formHeaders.map((key) => {
        const tag = lan[key] || key;
        const baseCol = {
          id: key,
          accessorKey: key,
          header: tag,
          enableSorting: true,
          enableColumnDragging: true,
          enableColumnResizing: true,
          muiTableHeadCellProps: { align: 'center' },
          muiTableBodyCellProps: { align: 'center' },
        };
        switch (key) {
          case 'id': return { ...baseCol, size: 40, grow: true, filterVariant: 'text',
            enableClickToCopy: true, filterFn: (row, columnId, filterValue) =>
              row.getValue(columnId)?.toString().includes(filterValue?.toString()),
            Cell: ({ cell }) => cell.getValue(), };
          case 'name': return { ...baseCol, size: 200, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} /> };
          case 'numberFields': return { ...baseCol, size: 120, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'originType': return { ...baseCol, size: 200, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'status': return {
            ...baseCol, size: 90, grow: true, enableSorting: false, enableColumnFilter: false,
            Cell: ({ cell }) => <FormStatus active={cell.getValue()} lan={lan} /> };
          case 'reviewable': return {
            ...baseCol, size: 90, grow: true, enableSorting: false, enableColumnFilter: false,
            Cell: ({ cell }) => <FormReviewable active={cell.getValue()} lan={lan} /> };
          case 'partnerPermissions': return { ...baseCol, size: 200, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'creationDate': return { ...baseCol, size: 120, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'lastUpdateDate': return { ...baseCol, size: 120, grow: true,
            Cell: ({ cell }) => cell.getValue() };
          case 'responsible': return { ...baseCol, size: 200, grow: true,
            Cell: ({ cell }) => <EllipsisTextCell value={cell.getValue()} /> };
          default:
            return baseCol;
        }
      });
    default:
      console.warn(`Unknown smartTableId: ${smartTableId}`);
      return [];
  }
};
export const getSmartAutoAssignTableColumns = (lan, onRowClick) => {
  const baseCol = (key, extra = {}) => ({
    id: key,
    accessorKey: key,
    header: lan[key] || key,
    enableSorting: true,
    enableColumnDragging: true,
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnActions: false,
    enableHiding: true,
    muiTableHeadCellProps: { align: 'center' },
    muiTableBodyCellProps: { align: 'center' },
    size: 100,
    ...extra,
  });

  return [
    baseCol('taskId', {
      size: 150,
      Cell: ({ row }) => (
        <TaskDetailButton
          value={row.original.taskId}
          onClick={() => onRowClick?.(row.original)}
        />
      ),
    }),
    baseCol('idCustom', { size: 250 }),
    baseCol('folio', {
      size: 125, enableClickToCopy: true, Cell: ({ cell }) => (
        <EllipsisTextCell value={cell.getValue()} />)}),
    baseCol('origin', {
      header: `${lan.company}/${lan.client}`,
      size: 225, enableClickToCopy: true, Cell: ({ cell }) => (
        <EllipsisTextCell value={cell.getValue()} />)}),
    baseCol('template', {
      header: lan.template || 'template',
      size: 200, enableClickToCopy: true, Cell: ({ cell }) => (
        <EllipsisTextCell value={cell.getValue()} />)}),
    baseCol('taskType', { size: 200, Cell: ({ cell }) => cell.getValue() }),
    baseCol('status', {
      size: 150, filterVariant: 'select', filterSelectOptions: getAutoAssignStatusFilterOptions(lan),
      Cell: ({ cell }) => <AutoAssignTaskStatus value={cell.getValue()} />,
    }),
    baseCol('priority', {
      header: lan.priority || 'priority',
      size: 180,
      filterVariant: 'select',
      filterSelectOptions: [
        { label: lan[`severity_1`] || 'High', value: 1 },
        { label: lan[`severity_2`] || 'Medium', value: 2 },
        { label: lan[`severity_3`] || 'Low', value: 3 },
        { label: lan.personalized || 'Personalized', value: 'custom' },
      ],
      filterFn: (row, _columnId, filterValue) => {
        const value = Number(row.original.priority);
        if (filterValue === 'custom') return value === 0 || value > 3;
        return value === Number(filterValue);
      },
      Cell: ({ row }) => {
        const { priority, priorityName } = row.original;
        return (
          lan[`severity_${priority}`] ||
          priorityName ||
          lan.personalized
        );
      },
    }),
    baseCol('responseTime', {
      header: lan.responseTime || 'Response Time',
      size: 250,
      Cell: ({ cell }) => cell.getValue(),
    })
  ];
};
export const buildIsochronousColumns = (lan) => {
  const baseCol = (key, extra = {}) => ({
    id: key,
    accessorKey: key,
    header: lan[key] || key,
    enableSorting: true,
    enableColumnDragging: true,
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnActions: true,
    enableHiding: true,
    muiTableHeadCellProps: { align: 'center' },
    grow: true,
    size: 100,
    ...extra,
  });

  return [
    baseCol('id', { size: 30, muiTableBodyCellProps: { align: 'center' }, enableColumnActions: false,
      enableClickToCopy: true, Cell: ({ cell }) => cell.getValue()}),
    baseCol('isochronous', { muiTableBodyCellProps: { align: 'center' }, enableColumnActions: false,
      enableSorting: false, Cell: ({ row }) => (
        <CellIsochronous key={`${row.original.id}-${row.original.type}`} isochronous={row.original} />
      )}),
    baseCol('type', { muiTableBodyCellProps: { align: 'center' }, enableColumnActions: false,
      Cell: ({ row }) => (<CellType isochronous={row.original} />)}),
    baseCol('users', {
      muiTableHeadCellProps: { align: 'left' }, enableColumnActions: false, enableSorting: false,
      Cell: ({ row }) => (<CellUsersNumber isochronous={row.original} />)}),
    baseCol('originPoint', {
      muiTableHeadCellProps: { align: 'left' }, enableClickToCopy: true, enableColumnActions: false,
      Cell: ({ row }) => (
        <TextIcon
          icon={<LocationIcon style={{ color: '#455A64' }} />}
          text={row.original.address}
          textStyle={{ fontSize: '10pt' }}
        />
      )})
  ];
};
